export const UPDATE_MODAL_DISPLAY_STATE='UPDATE_MODAL_DISPLAY_STATE'
export const COMPLAINT_MAIN_SET_TAB='COMPLAINT_MAIN_SET_TAB'
export const GET_INS_SHARED_MASTERS_END='GET_INS_SHARED_MASTERS_END'
export const GET_SHARED_COMPLAINTS_FEEDBACK_MASTERS_END='GET_SHARED_COMPLAINTS_FEEDBACK_MASTERS_END'
export const COLLAPSE_SEARCH_RESULT='COLLAPSE_SEARCH_RESULT'
export const COLLAPSE_SEARCH='COLLAPSE_SEARCH'
/* Complaint Search */
export const UPDATE_COMPLAINTS_SEARCH_PARAMS='UPDATE_COMPLAINTS_SEARCH_PARAMS'
export const RESET_COMPLAINT_SEARCH_INFORMATION='RESET_COMPLAINT_SEARCH_INFORMATION'
export const UPDATE_COMPLAINT_SEARCH_RESULT='UPDATE_COMPLAINT_SEARCH_RESULT'
export const GET_SUB_LOB_MASTERS_END='GET_SUB_LOB_MASTERS_END'
export const GET_COMPLAINT_TYPE_MASTERS_END='GET_COMPLAINT_TYPE_MASTERS_END'
export const GET_COMPLAINT_INFO_END='GET_COMPLAINT_INFO_END'
export const RESET_COMPLAINT_SEARCH_RESULT='RESET_COMPLAINT_SEARCH_RESULT'
/* New Complaint */ 
export const UPDATE_NEW_COMPLAINTS_PARAMS='UPDATE_NEW_COMPLAINTS_PARAMS'
export const RESET_NEW_COMPLAINT_INFORMATION='RESET_NEW_COMPLAINT_INFORMATION'
export const CHANGE_VALIDATION_ERROR_MESSAGE='CHANGE_VALIDATION_ERROR_MESSAGE'
export const CREATE_NEW_DIALOG_SUCCESS='CREATE_NEW_DIALOG_SUCCESS'
export const RESET_VALIDATION_ERROR_MESSAGE='RESET_VALIDATION_ERROR_MESSAGE'
export const UPDATE_COMPLAINT_NUMBER_SEARCH_PARAMS='UPDATE_COMPLAINT_NUMBER_SEARCH_PARAMS'
export const RESET_COMPLAINT_NUMBER_SEARCH='RESET_COMPLAINT_NUMBER_SEARCH'
export const RESET_COMPLAINT_NUMBER='RESET_COMPLAINT_NUMBER'
export const GET_COMPLAINT_NUMBER_RESULTS_END='GET_COMPLAINT_NUMBER_RESULTS_END'
export const RESET_NEW_COMPLAINT_INFORMATION_WITHOUT_COMPLAINT_NUMBER='RESET_NEW_COMPLAINT_INFORMATION_WITHOUT_COMPLAINT_NUMBER'
/* Complaint Details */
export const UPDATE_COMPLAINTS_DETAILS_PARAMS='UPDATE_COMPLAINTS_DETAILS_PARAMS'
export const RESET_COMPLAINT_DETAILS_INFORMATION='RESET_COMPLAINT_DETAILS_INFORMATION'
export const UPDATE_COMMENT_PARAMS='UPDATE_COMMENT_PARAMS'
export const RESET_COMMENT_INFORMATION='RESET_COMMENT_INFORMATION'
export const GET_COMPLAINT_DETAILS_END='GET_COMPLAINT_DETAILS_END'
export const RESET_USER_LOG_INFORMATION='RESET_USER_LOG_INFORMATION'
export const GET_COMPLAINT_DETAILS_ORIGINAL_END='GET_COMPLAINT_DETAILS_ORIGINAL_END'
/* Complaint Documents */ 
export const UPDATE_FILE_CHANGE_END='UPDATE_FILE_CHANGE_END'
export const UPDATE_DOCUMENT_PARAMS_END='UPDATE_DOCUMENT_PARAMS_END'
export const UPDATE_DOCUMENT_CHECKBOX_PARAMS='UPDATE_DOCUMENT_CHECKBOX_PARAMS'
export const ADD_NEW_DOCUMENT='ADD_NEW_DOCUMENT'
export const DELETE_DOCUMENT_FROM_GRID='DELETE_DOCUMENT_FROM_GRID'
export const UPDATE_DOCUMENTS_TABLE_ID='UPDATE_DOCUMENTS_TABLE_ID'
export const GET_DISTINCT_DOCUMENT_PAGE_ID='GET_DISTINCT_DOCUMENT_PAGE_ID'
export const GET_QUOTE_DOCUMENT_LIST_END='GET_QUOTE_DOCUMENT_LIST_END'
export const RESET_DOCUMENT_INFORMATION='RESET_DOCUMENT_INFORMATION'

export const TOGGLE_CONFRIM_POPUP='TOGGLE_CONFRIM_POPUP'
export const CONFIRM_YES='CONFIRM_YES'
export const CONFIRM_NO='CONFIRM_NO'

export const UPDATE_WHISTLE_BLOWING_PARAMS='UPDATE_WHISTLE_BLOWING_PARAMS'
export const RESET_NEW_WHISTLE_BLOWING_WITHOUT_COMPLAINT_NUMBER='RESET_NEW_WHISTLE_BLOWING_WITHOUT_COMPLAINT_NUMBER'